import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { mathConverterMap } from './mathPropsToCss'

/**
 * Enriches the converters registry with all math function style property converters.
 * Math function converters handle CSS mathematical expressions like calc(), min(), max(), etc.
 */
export function enrichMathFunctionConverters(): void {
	// Register all math function converters
	Object.entries(mathConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
